export interface IPromotionMessage {
  isDiscountApplied: boolean;
  firstTimeTransfer: boolean;
  isNthTransactionApplicable: boolean;
  promotionType: string;
  marginBottom: number;
  rightMargin: number;
  discountTagTopMargin: number;
  discountTagFlexStartAlignment: boolean;
  hvtThresholdLimit: {
    enabled: boolean;
    thresholdLimit: number;
  };
  grossSourceAmount: number;
  sourceCurrency: string;
  upsellOfferDiscountId: string;
  tier: string;
}

type PromotionMessage = {
  message: string;
  linkMessage: string;
  redirectUrl: string;
};

type HVTPromotionsMessage = {
  discountMsg: {
    message: string;
    linkMessage: string;
    redirectUrl: string;
  };
  discountAppliedMsg: {
    message: string;
    linkMessage: string;
    redirectUrl: string;
  };
};

type PromotionsCategory = {
  FTT: PromotionMessage;
  NTh: PromotionMessage;
  HVT: HVTPromotionsMessage;
  UPSELL: PromotionMessage;
};

export type PromotionsData = {
  FEE_BASED: PromotionsCategory;
  FX_BASED: PromotionsCategory;
};

export const PROMOTIONS_MSG_FEE_BASED = {
  FTT: {
    message: `Your first transaction comes with a discount/zero fees!`,
    linkMessage: 'Learn more',
    redirectUrl: 'special-first-transfer-offer'
  },
  NTh: {
    message: `You get discounted fees on this transfer!`,
    linkMessage: 'Learn more',
    redirectUrl: 'terms-policies'
  },
  HVT: {
    discountMsg: {
      message: `Sending over {SOURCE_AMOUNT} {SOURCE_CURRENCY}?`,
      linkMessage: `You’ll get a special discount`,
      redirectUrl: 'large-transfers'
    },
    discountAppliedMsg: {
      message: `You’re sending a large amount so we gave you a special discount! Plus, you get extra support.`,
      linkMessage: 'Learn more',
      redirectUrl: 'large-transfers'
    }
  },
  UPSELL: {
    message: `You get discounted fees on this transfer!`,
    linkMessage: 'Learn more',
    redirectUrl: 'terms-policies'
  }
};

export const PROMOTIONS_MSG_FX_BASED = {
  FTT: {
    message: `Your first transaction comes with a special FX rate + zero fees!`,
    linkMessage: 'Learn more',
    redirectUrl: 'special-first-transfer-offer'
  },
  NTh: {
    message: `You get special FX rate on this transfer!`,
    linkMessage: 'Learn more',
    redirectUrl: 'terms-policies'
  },
  HVT: {
    discountMsg: {
      message: `Sending over {SOURCE_AMOUNT} {SOURCE_CURRENCY}?`,
      linkMessage: `You’ll get a special discount`,
      redirectUrl: 'large-transfers'
    },
    discountAppliedMsg: {
      message: `You’re sending a large amount so we gave you a special discount! Plus, you get extra support.`,
      linkMessage: 'Learn more',
      redirectUrl: 'large-transfers'
    }
  },
  UPSELL: {
    message: `You get special FX rate on this transfer!`,
    linkMessage: 'Learn more',
    redirectUrl: 'terms-policies'
  }
};
